import { LabelRegular, SuperscriptText } from 'smoothie';

const FDIC_DISCLOSURE_TEXT =
    'Funds in your Fruitful deposit account(s) are held at Emigrant Bank, Member FDIC and are eligible for FDIC insurance up to $250,000, inclusive of any other deposits you may already hold at the bank in the same ownership capacity. Fruitful Financial, LLC is not an FDIC-insured bank and FDIC insurance only covers the failure of Emigrant Bank. Fruitful Financial, LLC, must satisfy certain conditions for pass-through deposit insurance coverage to apply.';

export const FDICDisclosure = ({
    color = '$gray900',
    superscript,
}: {
    color?: string;
    superscript?: number;
}) => {
    if (superscript == null) {
        return (
            <LabelRegular color={color}>{FDIC_DISCLOSURE_TEXT}</LabelRegular>
        );
    }

    return (
        <SuperscriptText
            superscript={superscript}
            textAfter={FDIC_DISCLOSURE_TEXT}
            textComponent={LabelRegular}
            textProps={{ color }}
        />
    );
};
